import { HTTP, authHeader, HTTP_FILE } from './http-service';

class PersonDocumentService {
  create(payload) {
    return HTTP.post(`/TrustmarkPersonDocument`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      },
    );
  }

  getSignedUrl(trustmarkPersonDocumentId, filename) {
    return HTTP_FILE.get(
      `/TrustmarkPersonFile/GetPresignedPost/${trustmarkPersonDocumentId}?filename=${encodeURIComponent(filename)}`,
    ).then((response) => {
      return response.data;
    });
  }

  getDownloadUrl(link) {
    return HTTP_FILE.get(`/TrustmarkPersonFile/download/${encodeURIComponent(link)}`).then(
      (response) => {
        return response.data;
      },
    );
  }

  deleteFile(link) {
    return HTTP_FILE.delete(`/TrustmarkPersonFile/${encodeURIComponent(link)}`).then((response) => {
      return response.data;
    });
  }
}

export default new PersonDocumentService();
